export type Specialty =
  | 'Nephrologist'
  | 'Cardiologist'
  | 'Endocrinologist'
  | 'PCP'

export interface AppState {
  quizAnswer: Specialty | null
  selectedSpecialty: Specialty | null
  predictedBehavior: string | null
  predictedDriver: string | null
  predictedBarrier: string | null
  // Perception layer
  perceptionMode: boolean
  perceptionNeph: 'Early / Proactive' | 'Balanced' | 'Late / Cautious' | null
  perceptionCardio: 'Early / Proactive' | 'Balanced' | 'Late / Cautious' | null
  perceptionEndo: 'Early / Proactive' | 'Balanced' | 'Late / Cautious' | null
  perceptionPCP: 'Early / Proactive' | 'Balanced' | 'Late / Cautious' | null
}

export const SPECIALTY_COLORS: Record<Specialty, string> = {
  Nephrologist: '#E8871E',
  Cardiologist: '#C62828',
  Endocrinologist: '#C4B6B8',
  PCP: '#D4547A',
}

export const SPECIALTY_BG_COLORS: Record<Specialty, string> = {
  Nephrologist: 'bg-nephrologist',
  Cardiologist: 'bg-cardiologist',
  Endocrinologist: 'bg-endocrinologist',
  PCP: 'bg-pcp',
}

export const SPECIALTY_TEXT_COLORS: Record<Specialty, string> = {
  Nephrologist: 'text-nephrologist',
  Cardiologist: 'text-cardiologist',
  Endocrinologist: 'text-endocrinologist',
  PCP: 'text-pcp',
}

export const SPECIALTY_BORDER_COLORS: Record<Specialty, string> = {
  Nephrologist: 'border-nephrologist',
  Cardiologist: 'border-cardiologist',
  Endocrinologist: 'border-endocrinologist',
  PCP: 'border-pcp',
}

export interface StepProps {
  state: AppState
  updateState: (updates: Partial<AppState>) => void
  nextStep: () => void
  prevStep: () => void
  goToStep: (step: number) => void
  resetApp?: () => void
}
